import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  TextField,
  useMediaQuery, // Import useMediaQuery for responsive adjustments
  useTheme, // Import useTheme for breakpoints
} from '@mui/material';
import Navbar from '../components/Navbar';
import PurchaseOrderTable from '../components/PurchaseOrderTable';
import colors from '../theme/Colors';
import AddIcon from '@mui/icons-material/Add';
import CustomSelect from '../components/CustomSelect';
import { api } from '../helpers/apiRequest';
import { pageAccessList } from '../helpers/pageAccessList';

function PurchaseOrder() {
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [refreshTable, setRefreshTable] = useState(false);
  const [userInfo] = useState(JSON.parse(localStorage.getItem('user')));
  const [isAddingNewRow, setIsAddingNewRow] = useState(false);
  const [merchants, setMerchants] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [pstyles, setPstyles] = useState([]);
  const [items, setItems] = useState([]);
  const [pstyle, setPstyle] = useState("");
  const [item, setItem] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState('all');
  const [selectedMerchant, setSelectedMerchant] = useState('all');
  const [accessControl, setAccessControl] = useState({});

  // Material-UI hooks for responsiveness
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Less than 600px

  const fetchCurrentUser = async () => {
    try {
      let user = await localStorage.getItem('user');
      user = JSON.parse(user);

      if (user) {
        const res = await api.get(`/users/get/routes?userId=${userInfo?.id}`);
        const accessArray = res.data.message || [];
        const accessMapFromServer = accessArray.reduce((map, item) => {
          map[item.route] = item.allowed;
          return map;
        }, {});

        const accessMap = pageAccessList.reduce((acc, page) => {
          acc[page.key] = accessMapFromServer[page.key] || false;
          return acc;
        }, {});
        // console.log("setAccessControl", accessControl); // Removed console.log during render
        setAccessControl(accessMap);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchCurrentUser();
  }, []);

  useEffect(() => {
    if (userInfo.role === 'admin') {
      fetchCustomers();
      fetchMerchants();
    }
    if (userInfo?.role === 'merchant') {
      fetchCustomers(userInfo?.id);
    }
  }, [userInfo.role, userInfo?.id]); // Added userInfo.id to dependency array

  // useEffect(() => {
  //   console.log("customers:", customers); // Removed unnecessary console.log
  // }, [customers]);

  const fetchCustomers = async (id) => {
    try {
      console.log("user :",userInfo);
      const endpoint = userInfo?.role === 'admin' ? 'users/users/role/customer' : `users/merchant/customers/${userInfo?.id}`
      console.log("gonna send this endpoint:",endpoint);
      const response = await api.get(endpoint);
      console.log("gonna send this response:",response);
      // console.log("response?.data?.data:", response?.data?.data); // Removed console.log
      setCustomers([{ _id: 'all', name: 'All Customers' }, ...response?.data?.data]);
    } catch (error) {
      console.error('Error fetching customers:', error); // Changed error message for clarity
    }
  };

  useEffect(() => {
    const searchTimeout = setTimeout(() => {
      setRefreshTable(true);
    }, 500);

    return () => clearTimeout(searchTimeout);
  }, [selectedCustomer, selectedMerchant]); // Added selectedMerchant to dependencies

  const fetchMerchants = async () => {
    try {
      const response = await api.get('users/users/role/merchant');
      if (response.status) {
        setMerchants([{ _id: 'all', name: 'All Merchants' }, ...response.data.data]);
      }
    } catch (error) {
      console.error('Error fetching merchants:', error);
    }
  };

  const handleClick = () => {
    setIsAddingNewRow(true);
  };

  const handleMerchantChange = (e) => {
    setSelectedMerchant(e.target.value);
    // setRefreshTable(true); // Handled by useEffect with debounce
  };

  const handleCustomerChange = (e) => {
    // console.log("e:", e); // Removed console.log
    setSelectedCustomer(e.target.value);
    // setRefreshTable(true); // Handled by useEffect with debounce
  };
  useEffect(() => {

  }, [item, pstyle]);
  // useEffect(() => {
  //   const fetchPstyles = async () => {
  //     try {
  //       const res = await api.get("/orders/getPStyles");
  //       setPstyles(res?.data?.data || []);
  //     } catch (err) {
  //       console.error("Error fetching PStyles:", err);
  //     }
  //   };
  //   fetchPstyles();
  // }, []);
  useEffect(() => {
    const fetchPstyles = async () => {
      try {
        const url = (selectedCustomer && selectedCustomer!=='all')
          ? `/orders/getPStyles?customer=${encodeURIComponent(selectedCustomer)}`
          : `/orders/getPStyles`;

        const res = await api.get(url);
        setPstyles(res?.data?.data || []);
      } catch (err) {
        console.error("Error fetching PStyles:", err);
      }
    };

    fetchPstyles();
  }, [selectedCustomer]);
  // Fetch Items whenever Pstyle changes
  // useEffect(() => {
  //   const fetchItems = async () => {
  //     try {
  //       const url = pstyle
  //         ? `/orders/getItems?pstyle=${encodeURIComponent(pstyle.name)}`
  //         : `/orders/getItems`;

  //       const res = await api.get(url);
  //       setItems(res?.data?.data || []);
  //     } catch (err) {
  //       console.error("Error fetching Items:", err);
  //     }
  //   };

  //   fetchItems();
  // }, [pstyle]);
  useEffect(() => {
    const fetchItems = async () => {
      try {
        let url = "/orders/getItems";

        const queryParams = [];
        
        if (pstyle) queryParams.push(`pstyle=${encodeURIComponent(pstyle.target?.value)}`);
        if (selectedCustomer && selectedCustomer!=='all') queryParams.push(`customer=${encodeURIComponent(selectedCustomer)}`);

        if (queryParams.length > 0) {
          url += `?${queryParams.join("&")}`;
        }

        const res = await api.get(url);
        setItems(res?.data?.data || []);
      } catch (err) {
        console.error("Error fetching Items:", err);
      }
    };

    fetchItems();
  }, [pstyle, selectedCustomer]);
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      padding: { xs: 1, sm: 2, md: 3 }, // Responsive padding
      width: '95%', // Take full available width
      maxWidth: '1400px', // Limit content width on very large screens
      margin: '0 auto', // Center the content
    }}>
      <Navbar title="Purchase Order" />
      <Box
        sx={{
          marginTop: { xs: 8, sm: 10 }, // Adjust top margin for fixed Navbar on small screens
          marginBottom: { xs: 2, sm: 3 }, // Responsive bottom margin
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' }, // Stack on small, row on medium/large
          alignItems: { xs: 'flex-start', md: 'center' }, // Align items (top for stacked, center for row)
          gap: { xs: 2, sm: 3 }, // Responsive gap between filter group and button
          justifyContent: 'space-between', // Push button to end on large screens
        }}
      >
        {/* Filters Box */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap', // Allow filters to wrap to next line
            gap: { xs: 1.5, sm: 2 }, // Responsive gap between individual filters
            width: { xs: '100%', md: 'auto' }, // Full width on small, auto on medium/large
            justifyContent: { xs: 'center', sm: 'flex-start' } // Center filters on xs, left-align on sm+
          }}
        >
          {(userInfo?.role === 'admin' || userInfo?.role === 'merchant') && (
            <><CustomSelect
              label="Filter by Customer"
              value={selectedCustomer}
              onChange={handleCustomerChange}
              options={customers?.map((customer) => ({
                id:  userInfo?.role === 'admin'?customer?._id :customer?.customer?._id,
                name:  userInfo?.role === 'admin'?customer?.name : customer?.customer?.name
              }))}
              sx={{
                minWidth: { xs: 'calc(50% - 8px)', sm: 180, md: 200 }, // Two columns on xs, wider on sm+
                flexGrow: 1, // Allow it to grow
              }}
              size={isSmallScreen ? "small" : "medium"} // Smaller input on small screens
            />
             <CustomSelect
            label="Filter by PStyle/Style"
            value={pstyle.name}
            onChange={(value) => {
              setPstyle(value);
              setItem(""); // reset item when pstyle changes
            }}
            options={pstyles.map((ps) => ({
              id: ps,
              name: ps,
            }))}
            sx={{
              minWidth: { xs: "calc(50% - 8px)", sm: 180, md: 200 },
              flexGrow: 1,
            }}
            size={isSmallScreen ? "small" : "medium"}
          />
          {/* <TextField
            label="Filter by Item"
            value={item}
            onChange={(e) => setItem(e.target.value)}
            sx={{ minWidth: 200 }}
          /> */}
          <CustomSelect
            label="Filter by Item"
            value={item.name}
            onChange={setItem}
            options={items.map((it) => ({
              id: it?.trim(),   // clean spaces
              name: it?.trim(), // show cleaned value
            }))}
            sx={{
              minWidth: { xs: "calc(50% - 8px)", sm: 180, md: 200 },
              flexGrow: 1,
            }}
            size={isSmallScreen ? "small" : "medium"}
          />

          <TextField
            label="From Date"
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            sx={{ minWidth: 200 }}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            label="To Date"
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            sx={{ minWidth: 200 }}
            InputLabelProps={{ shrink: true }}
          />
            </>
          )}
          {/* <TextField
            label="Filter by PStyle/Style"
            value={pstyle}
            onChange={(e) => setPstyle(e.target.value)}
            sx={{ minWidth: 200 }}
          /> */}
         
        </Box>

        {/* Add Purchase Order Button */}
        {(accessControl["add-purchase-order"] === true) ? (
          <Button
            variant="contained"
            sx={{
              backgroundColor: colors.primary,
              color: 'black',
              '&:hover': {
                backgroundColor: colors.primary,
                opacity: 0.9
              },
              width: { xs: '100%', md: 'auto' }, // Full width on small, auto on medium/large
              mt: { xs: 2, md: 0 }, // Top margin on small, no top margin on medium/large
              minHeight: { xs: '48px', sm: '56px' } // Ensure button is tappable
            }}
            startIcon={<AddIcon />}
            onClick={handleClick}
          >
            Add Purchase Order
          </Button>
        ) : null}
      </Box>

      {/* Purchase Order Table */}
      <PurchaseOrderTable
        userInfo={userInfo}
        item={item}
        pstyle={pstyle}
        setItem={setItem}
        setPstyle={setPstyle}
        fromDate={fromDate}
        toDate={toDate}
        refreshTable={refreshTable}
        setRefreshTable={setRefreshTable}
        isAddingNewRow={isAddingNewRow}
        setIsAddingNewRow={setIsAddingNewRow}
        customerSearch={selectedCustomer}
        selectedMerchant={selectedMerchant}
        accessControl={accessControl}
      />
    </Box>
  );
}

export default PurchaseOrder;
